package kz.dentalcrm.app.data.network.response_model.protocol_templates

import kotlinx.serialization.Serializable

@Serializable
data class Option(
    val id: Int = 0,
    val is_custom: Int,
    val value: String
)